import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "rotateButton"];

  connect() {
    console.log("API Toggle controller connected");
    this.updateRotateButtonVisibility();
  }

  toggle(event) {
    const isChecked = event.target.checked;
    console.log("API toggle triggered:", isChecked);
    
    if (isChecked) {
      const confirmationText = this.element.dataset.apiToggleEnableConfirmationText || 
        "Are you sure you want to enable API access? This will generate new API credentials.";
      
      if (!confirm(confirmationText)) {
        event.preventDefault();
        this.checkboxTarget.checked = false;
        console.log("API enable cancelled by user");
        return;
      }
    }
    
    // Update rotate button visibility
    this.updateRotateButtonVisibility(isChecked);
    
    // Submit the form
    const form = this.element.querySelector("form");
    if (form) {
      console.log("Submitting form...");
      form.requestSubmit();
    } else {
      console.error("No form found in API toggle controller");
    }
  }

  updateRotateButtonVisibility(isChecked = null) {
    if (!this.hasRotateButtonTarget) {
      console.log("No rotate button target found");
      return;
    }

    const shouldShow = isChecked !== null ? isChecked : this.checkboxTarget.checked;
    
    if (shouldShow) {
      console.log("Showing rotate button");
      this.rotateButtonTarget.classList.remove("hidden");
    } else {
      console.log("Hiding rotate button");
      this.rotateButtonTarget.classList.add("hidden");
    }
  }
}
